var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg20Years(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.734 40.874C55.3653 39.7328 55.504 38.3213 54.8161 37.3714C54.1213 36.412 52.7378 36.1116 51.7832 35.4134C50.8379 34.7221 50.1298 33.4887 48.9941 33.1182C47.8984 32.7606 46.609 33.3285 45.3947 33.3285C44.1804 33.3285 42.8911 32.7606 41.7954 33.1182C40.6598 33.4887 39.9517 34.722 39.0064 35.4133C38.0517 36.1115 36.6682 36.4119 35.9735 37.3713C35.2855 38.3212 35.4242 39.7328 35.0554 40.874C34.6996 41.975 33.75 43.0297 33.75 44.25C33.75 45.4703 34.6996 46.525 35.0554 47.6261C35.4241 48.7672 35.2854 50.1787 35.9734 51.1286C36.6681 52.088 38.0516 52.3884 39.0063 53.0866C39.9516 53.7779 40.6597 55.0113 41.7954 55.3818C42.8911 55.7394 44.1804 55.1716 45.3947 55.1716C46.609 55.1716 47.8984 55.7394 48.9941 55.3818C50.1297 55.0113 50.8379 53.7779 51.7831 53.0867C52.7377 52.3885 54.1212 52.088 54.8161 51.1287C55.504 50.1788 55.3653 48.7673 55.7341 47.6261C56.0898 46.525 57.0395 45.4703 57.0395 44.25C57.0395 43.0297 56.0898 41.975 55.734 40.874Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5461 43.9618L44.3041 46.7197L49.2434 41.7803",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1334 34.7818C52.2111 31.9698 53.25 27.9275 53.25 22.6549C53.25 16.9498 52.1256 12.7993 49.8768 10.2036C47.6524 7.60792 44.4748 6.31006 40.3438 6.31006C36.2128 6.31006 33.023 7.60792 30.7742 10.2036C28.5498 12.7993 27.4376 16.9498 27.4376 22.6549C27.4376 28.3601 28.5498 32.5105 30.7742 35.1063C31.9037 36.41 33.2706 37.3863 34.875 38.0353M40.3438 31.7805C42.006 31.7805 42.837 30.7801 42.837 28.7792V16.5307C42.837 14.5298 42.006 13.5294 40.3438 13.5294C38.6816 13.5294 37.8506 14.5298 37.8506 16.5307V28.7792C37.8506 30.7801 38.6816 31.7805 40.3438 31.7805Z",
    stroke: "#43768A",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55341 34.944C3.55341 32.6187 3.85895 30.5637 4.47004 28.7792C5.10557 26.9946 6.1322 25.3182 7.54992 23.75C8.96764 22.1547 10.9231 20.5053 13.4164 18.8019C14.1497 18.2882 14.663 17.8555 14.9563 17.504C15.2741 17.1255 15.433 16.6794 15.433 16.1656C15.433 15.057 14.7119 14.5028 13.2697 14.5028C12.1942 14.5028 10.9598 14.8137 9.56651 15.4356C8.17323 16.0575 6.91439 16.8416 5.78999 17.788L3.62674 9.14909C5.19112 8.28385 6.98772 7.55381 9.01653 6.95896C11.0453 6.33707 13.0864 6.02612 15.1396 6.02612C18.5128 6.02612 21.1283 6.8508 22.986 8.50016C24.8437 10.1495 25.7726 12.4884 25.7726 15.5167C25.7726 17.139 25.4426 18.5721 24.7826 19.8159C24.1471 21.0326 23.3649 22.0601 22.436 22.8983C21.5316 23.7365 20.3461 24.6963 18.8795 25.7779C17.2418 26.9676 16.0318 27.9951 15.2496 28.8603C14.4919 29.6985 14.113 30.6719 14.113 31.7805H18.5495V29.4687H26.0659V38.432H3.55341V34.944Z",
    stroke: "#43768A",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 44.2502V46.7255C3.75 47.6331 4.49262 48.3757 5.40026 48.3757C6.3079 48.3757 7.05051 47.6331 7.05051 46.7255V44.2502",
    stroke: "#43768A",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40033 48.3756V50.8511",
    stroke: "#43768A",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8265 50.8511H9.9386V44.2501H12.8265",
    stroke: "#43768A",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2274 47.5505H11.6713",
    stroke: "#43768A",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5496 50.8511V45.9003C15.5496 44.9927 16.2921 44.2501 17.1998 44.2501C18.1075 44.2501 18.8501 44.9927 18.8501 45.9003V50.8511",
    stroke: "#43768A",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9001 48.3757H18.4994",
    stroke: "#43768A",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7381 50.8511V47.5506",
    stroke: "#43768A",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7381 44.25H23.3884C24.2961 44.25 25.0387 44.9926 25.0387 45.9003C25.0387 46.8079 24.2961 47.5505 23.3884 47.5505H21.7381V44.25Z",
    stroke: "#43768A",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3884 47.5506L25.0387 50.8511",
    stroke: "#43768A",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6066 44.5546L30.1679 44.3729C29.3439 44.0317 28.3907 44.4264 28.0495 45.2504C27.7081 46.0743 28.103 47.0276 28.9269 47.3689L29.3656 47.5506L29.8044 47.7323C30.6282 48.0736 31.0231 49.0269 30.6818 49.8508C30.3406 50.6747 29.3873 51.0695 28.5633 50.7283L28.1246 50.5466",
    stroke: "#43768A",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20Years);
export default __webpack_public_path__ + "static/media/20_years.fd4f23cab64c80791942f1a4846c2d11.svg";
export { ForwardRef as ReactComponent };